import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { listAllCalledNumbers } from "api/list-all-called-numbers";
import { Card, Container, Grid, Typography, Box } from "@mui/material";
import "./styles.css";

const CalledNumbersDisplay = () => {
    const { username } = useParams();
    const queryParameters = new URLSearchParams(window.location.search);
    const game_id = queryParameters.get("game_id");

    const [newCall, setNewCall] = useState("");
    const [calledNums, setCalledNums] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (username && game_id) {
            document.title = `Bingo Caller - ${username} | MYBINGO`;
            fetchCalledNumbers();
        }
    }, [username, game_id]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (game_id) {
                fetchCalledNumbers();
            }
        }, 2000);

        return () => clearInterval(intervalId);
    }, [game_id]);

    const fetchCalledNumbers = async () => {
        try {
            let callData = await listAllCalledNumbers({ gameId: game_id });
            if (callData) {
                setCalledNums(callData?.data?.reverse() || []);
                setNewCall(callData?.newcall || "");
                setLoading(false);
            }
        } catch (error) {
            console.error("Failed to fetch called numbers:", error);
            setLoading(false);
        }
    };

    // const getBingoLetter = (number) => {
    //     const num = parseInt(number);
    //     if (num >= 1 && num <= 15) return 'B';
    //     if (num >= 16 && num <= 30) return 'I';
    //     if (num >= 31 && num <= 45) return 'N';
    //     if (num >= 46 && num <= 60) return 'G';
    //     if (num >= 61 && num <= 75) return 'O';
    //     return '';
    // };

    if (loading) {
        return (
            <Container maxWidth="lg" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h4" sx={{ color: '#fff' }}>Loading...</Typography>
            </Container>
        );
    }

    return (
        <Container maxWidth="lg" sx={{ minHeight: '100vh', py: 4 }}>
            {/* Header */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
                <div className="w-full container mx-auto p-2">
                    <div className="w-full flex items-center justify-between">
                        <a href="/" className="flex items-center text-indigo-400 no-underline hover:no-underline font-bold text-2xl lg:text-4xl">
                            mybingo<span className="bg-clip-text text-transparent bg-gradient-to-r from-green-400 via-pink-500 to-purple-500">.social</span>
                        </a>
                    </div>
                </div>
                {/* <Typography variant="h5" sx={{ color: '#9ca3af' }}>
                    Bingo Caller Display
                </Typography> */}
                {username && (
                    <Typography variant="h4" sx={{ color: '#999', mt: 1, fontWeight: 'bold' }}>
                        Game by: {username}
                    </Typography>
                )}
            </Box>

            {/* Current Call Display */}
            <Box sx={{ textAlign: 'center', mb: 6 }}>
                {newCall ? (
                    <Card sx={{ 
                        p: 6, 
                        backgroundColor: 'rgba(139, 69, 19, 0.9)', 
                        borderRadius: 4,
                        border: '4px solid #d97706',
                        boxShadow: '0 20px 40px rgba(217, 119, 6, 0.3)',
                        animation: 'pulse 2s infinite'
                    }}>
                        <Typography variant="h6" sx={{ color: '#fbbf24', mb: 2, fontWeight: 'bold' }}>
                            CURRENT CALL
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                            {/* <Typography 
                                variant="h1" 
                                sx={{ 
                                    color: '#f59e0b', 
                                    fontWeight: 'bold', 
                                    fontSize: { xs: '4rem', sm: '6rem', md: '8rem' },
                                    lineHeight: 1,
                                    textShadow: '0 4px 8px rgba(0,0,0,0.5)'
                                }}
                            >
                                {getBingoLetter(newCall)}
                            </Typography> */}
                            <Typography 
                                variant="h1" 
                                sx={{ 
                                    color: '#ffffff', 
                                    fontWeight: 'bold', 
                                    fontSize: { xs: '4rem', sm: '6rem', md: '8rem' },
                                    lineHeight: 1,
                                    textShadow: '0 4px 8px rgba(0,0,0,0.5)'
                                }}
                            >
                                {newCall}
                            </Typography>
                        </Box>
                    </Card>
                ) : (
                    <Card sx={{ 
                        p: 6, 
                        backgroundColor: 'rgba(55, 65, 81, 0.8)', 
                        borderRadius: 4,
                        border: '2px dashed #6b7280'
                    }}>
                        <Typography variant="h4" sx={{ color: '#9ca3af' }}>
                            Waiting for next call...
                        </Typography>
                    </Card>
                )}
            </Box>

            {/* Previously Called Numbers */}
            <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h4" sx={{ color: '#fff', mb: 3, fontWeight: 'bold' }}>
                    Previously Called Numbers
                </Typography>
                
                {calledNums && calledNums.length > 0 ? (
                    <Card sx={{ 
                        p: 3, 
                        backgroundColor: 'rgba(97, 134, 255, 0.1)', 
                        borderRadius: 3,
                        border: '1px solid rgba(97, 134, 255, 0.3)'
                    }}>
                        <Grid container spacing={1} justifyContent="center">
                            {calledNums
                                .filter(num => num.num !== newCall) // Exclude current call from previous numbers
                                .map((item, index) => (
                                <Grid item key={index}>
                                    <Box sx={{
                                        width: { xs: 50, sm: 60 },
                                        height: { xs: 50, sm: 60 },
                                        borderRadius: '50%',
                                        backgroundColor: '#4f46e5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '2px solid #6366f1',
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            transform: 'scale(1.1)',
                                            backgroundColor: '#6366f1'
                                        }
                                    }}>
                                        <Typography 
                                            variant="body2" 
                                            sx={{ 
                                                color: '#fff', 
                                                fontWeight: 'bold',
                                                fontSize: { xs: '0.875rem', sm: '1rem' }
                                            }}
                                        >
                                            {item.num}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                        
                        <Typography variant="body2" sx={{ color: '#9ca3af', mt: 3 }}>
                            Total Numbers Called: {calledNums.length}
                        </Typography>
                    </Card>
                ) : (
                    <Card sx={{ 
                        p: 4, 
                        backgroundColor: 'rgba(55, 65, 81, 0.5)', 
                        borderRadius: 3 
                    }}>
                        <Typography variant="h6" sx={{ color: '#9ca3af' }}>
                            No numbers called yet
                        </Typography>
                    </Card>
                )}
            </Box>

            <style jsx>{`
                @keyframes pulse {
                    0%, 100% {
                        transform: scale(1);
                        box-shadow: 0 20px 40px rgba(217, 119, 6, 0.3);
                    }
                    50% {
                        transform: scale(1.02);
                        box-shadow: 0 25px 50px rgba(217, 119, 6, 0.4);
                    }
                }
            `}</style>
        </Container>
    );
};

export default CalledNumbersDisplay;